import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const applyForTaxReliefAllOrPartAmount = atom({
  key: "applyForTaxReliefAllOrPartAmount",
  default: "applyForTaxReliefAllAmount",
  effects_UNSTABLE: [ocPersistAtom],
});
